var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E67D2D",
  d: "m9.045 7-.6.614c-.48.48-.78.886-.78 1.886H6.332v-.333c0-.74.3-1.407.78-1.887l.827-.84c.246-.24.393-.573.393-.94a1.333 1.333 0 1 0-2.667 0H4.332a2.667 2.667 0 0 1 5.333 0c0 .587-.24 1.114-.62 1.5Zm-1.38 5.167H6.332v-1.333h1.333M7 .834A6.667 6.667 0 1 0 13.665 7.5c0-3.687-3-6.667-6.666-6.667Z"
})));
export { SvgVector as ReactComponent };
export default __webpack_public_path__ + "1a2e2b132fb1535f89786df8452e78b2.svg";